module.exports = __webpack_public_path__ + "img/empty-jzx.b35226db.png";